// refs: https://github.com/amfe/lib-flexible
(function flexible(window, document) {
  const docEl = document.documentElement
  const maxWidth = 750 // PC大屏幕限制最大宽度，防止rem过大

  // set 1rem = viewWidth / 10
  function setRemUnit() {
    const width = Math.min(docEl.clientWidth, maxWidth)
    const rem = width / 10
    docEl.style.fontSize = `${rem}px`
  }

  setRemUnit()

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', (e) => {
    if (e.persisted)
      setRemUnit()
  })
}(window, document))
